$(document).ready(function() {

    var sideContact = $("#sideContact").width();
    var sideOpeningHours = $("#sideOpeningHours").width();
    var sideLogin = $("#sideLogin").width();

    $(".toggleSideContact").click(function() {

        if ($(this).hasClass('active')) {
            $('.toggleSideContact').removeClass("active");
            $("#sideBar").removeClass('active');
            $("#sideBarOverlay").fadeOut();
        } else {

            if (!$("#sideBar").hasClass('active')) {
                $("#sideLogin").hide();
                $("#sideOpeningHours").hide();
                $("#sideContact").show();

                $("#sideBarOverlay").fadeIn();
                $("#sideBar").addClass('active');
            } else {
                $("#sideBar").removeClass('active');
                window.setTimeout(function() {
                    $("#sideLogin").hide();
                    $("#sideOpeningHours").hide();
                    $("#sideContact").show();
                    $("#sideBar").addClass('active');
                    $('.toggleSideLogin').removeClass('active');
                    $('.toggleSideOpeningHours').removeClass('active');
                }, 300);
            }

            $('.toggleSideContact').addClass("active");
        }
    });

    $(".toggleSideOpeningHours").click(function() {

        if ($(this).hasClass('active')) {
            $('.toggleSideOpeningHours').removeClass("active");
            $("#sideBar").removeClass('active');
            $("#sideBarOverlay").fadeOut();
        } else {

            if (!$("#sideBar").hasClass('active')) {
                $("#sideContact").hide();
                $("#sideLogin").hide();
                $("#sideOpeningHours").show();

                $("#sideBarOverlay").fadeIn();
                $("#sideBar").addClass('active');
            } else {
                $("#sideBar").removeClass('active');
                window.setTimeout(function() {
                    $("#sideContact").hide();
                    $("#sideLogin").hide();
                    $("#sideOpeningHours").show();
                    $("#sideBar").addClass('active');
                    $('.toggleSideContact').removeClass('active');
                    $('.toggleSideLogin').removeClass('active');
                }, 300);
            }

            $('.toggleSideOpeningHours').addClass("active");
        }
    });

    $(".toggleSideLogin").click(function() {

        if ($(this).hasClass('active')) {
            $('.toggleSideLogin').removeClass("active");
            $("#sideBar").removeClass('active');
            $("#sideBarOverlay").fadeOut();

        } else {

            if (!$("#sideBar").hasClass('active')) {
                $("#sideLogin").show();
                $("#sideContact").hide();
                $("#sideOpeningHours").hide();

                $("#sideBarOverlay").fadeIn();
                $("#sideBar").addClass('active');

            } else {
                $("#sideBar").removeClass('active');
                window.setTimeout(function() {
                    $("#sideLogin").show();
                    $("#sideContact").hide();
                    $("#sideOpeningHours").hide();
                    $("#sideBar").addClass('active');
                    $('.toggleSideContact').removeClass('active');
                    $('.toggleSideOpeningHours').removeClass('active');
                }, 300);
            }

            $('.toggleSideLogin').addClass("active");
        }

    });
    $(".toggleSideService").click(function() {

        if ($("#sideBar").hasClass('active')) {
            $("#sideBar").removeClass('active');
            $("#sideBarOverlay").fadeOut();
            $(".toggleSideLogin").removeClass("active");
            $(".toggleSideContact").removeClass("active");
            $(".toggleSideOpeningHours").removeClass("active");
            $(".toggleSideService").removeClass("active");
            $("#sideLogin").hide();
            $("#sideContact").hide();
            $("#sideOpeningHours").hide();
        }

    });

    $("#sideBarOverlay").click(function() {
        $("#sideBarOverlay").fadeOut();
        $(".toggleSideLogin").removeClass("active");
        $(".toggleSideContact").removeClass("active");
        $(".toggleSideOpeningHours").removeClass("active");
        $(".toggleSideService").removeClass("active");
        $("#sideBar").removeClass('active');
    });




});

var hideSideContact = function() {

}
